import React from 'react';
import { Plugin, Template, TemplatePlaceholder } from '@devexpress/dx-react-core';
import { useTranslation } from 'react-i18next';
import { SEARCH_RESULTS } from '../../../i18n/keyConstants';

const OfficeHoursTableHeader = ({ children, tableSize }) => {
    const { t } = useTranslation();
    return (
        <Plugin>
            <Template name='header'>
                <div className='card-header d-lg-none py-2 tableSize c-black d-flex'>
                    <span className='d-lg-none my-auto mr-auto'>{t(SEARCH_RESULTS) } {tableSize}</span>
                    <div className='d-lg-none my-auto ml-auto'>{children[1]}</div>
                    <div className='d-lg-none my-auto ml-auto'>{children[2]}</div>
                </div>
                <div className='card-header d-flex py-2 tableSize justify-content-between position-relative'>
                    <span className='my-auto d-none d-lg-block'>{t(SEARCH_RESULTS)} {tableSize}</span>
                    <div className='m-auto'>{children[0]}</div>
                    <div className='my-auto d-none d-lg-block'>{children[1]}</div>
                    <div className='my-auto d-none d-lg-block'>{children[2]}</div>
                </div>
                <TemplatePlaceholder />
            </Template>
        </Plugin>
    );
};

export default OfficeHoursTableHeader;
